<template>
  <div>
    <span id="attach" style="margin: auto;">
      <v-menu
        fixed
        offset-y
        attach="#attachId"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-layout
            v-bind="attrs"
            v-on="on"
          >
            <slot />

          </v-layout>
        </template>
        <v-card>
          <v-card-text class="overflow-y-auto pa-0 ma-0">
            <v-layout row wrap justify-center>
              <v-flex xs12>
                <v-flex
                  xs12
                  class="pa-3 d-flex ma-0 align-center"

                  @click="editAdImage"
                >
                  <v-img
                    class="bg-white pa-1"
                    width="25"
                    height="40"
                    :aspect-ratio="1"
                    :src="cretiveIcon"
                  />
                  <v-list-tile-title class="ml-2">
                    Edit Design
                  </v-list-tile-title>
                </v-flex>
                <v-flex
                  xs12
                  class="pa-3 d-flex ma-0 align-center"
                  @click="editAdText"
                >
                  <v-img
                    class="bg-white pa-1"
                    width="25"
                    height="40"
                    :aspect-ratio="1"
                    :src="editIcon"
                  />
                  <v-list-tile-title class="ml-2">
                    Edit Text
                  </v-list-tile-title>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-menu>
    </span>
  </div>
</template>

<script>
import {
  VMenu,
  VFlex,
  VLayout,
  VCard,
  VCardText, VImg,
  VListTileTitle
} from 'vuetify/lib';
import onboardingRedirect from 'Mixins/onboardingRedirect';
import { mapActions, mapGetters } from 'vuex';
import { bizgainOnboardingImage } from 'Features/bizgainOnboarding/constants';
import { launchState } from '../../../constants';

export default {
  mixins: [onboardingRedirect],
  components: {
    VMenu,
    VFlex,
    VLayout,
    VCard,
    VCardText, VImg, VListTileTitle
  },
  props: ['googleAdEdit', 'id'],
  data() {
    return{
      cretiveIcon: bizgainOnboardingImage.creativeIcon,
      editIcon: bizgainOnboardingImage.editIcon
    }
  },
  computed: {
    ...mapGetters(['businessDetails', 'isInAppCampaign'])
  },
  methods: {
    ...mapActions(['addCreativeLogo']),
    async editAdText(){
      let newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
      newBusinessDetails.creativeDetail.selectedTemplateId = this.id;
      if(this.isInAppCampaign){
        await this.redirect({ id: this.id, isAppFlow: true }, { isAppFlow: true, ...{ ...this.$route.params, id: this.id } }, 2, launchState.FACEBOOKADEDIT, newBusinessDetails)
      }else{
        await this.redirect({ id: this.id, isAppFlow: true }, { id: this.id, isAppFlow: true, ...this.$route.params }, 2, launchState.FACEBOOKADEDIT, newBusinessDetails)
      }
    },
    async editAdImage(){
      this.addCreativeLogo({});
      let newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
      newBusinessDetails.creativeDetail.selectedTemplateId = this.id;
      if(this.isInAppCampaign){
        await this.redirect({ id: this.id, isAppFlow: true }, { id: this.id, isAppFlow: true, ...{ ...this.$route.params, id: this.id } }, 1, launchState.CREATIVESEDIT, newBusinessDetails);
      }else{
        await this.redirect({ id: this.id, isAppFlow: true }, { id: this.id, isAppFlow: true, ...this.$route.params }, 1, launchState.CREATIVESEDIT, newBusinessDetails);
      }
    },
    async editGoogleText(){
      let newBusinessDetails = JSON.parse(JSON.stringify(this.businessDetails));
      newBusinessDetails.creativeDetail.selectedTemplateId = this.id;
      if(this.isInAppCampaign){
        await this.redirect({ id: this.id, isAppFlow: true }, { id: this.id, isAppFlow: true, ...{ ...this.$route.params, id: this.id } }, 3, launchState.GOOGLEADEDIT, newBusinessDetails);
      }else{
        await this.redirect({ isAppFlow: true }, { isAppFlow: true, ...this.$route.params }, 3,  launchState.GOOGLEADEDIT, newBusinessDetails);
      }
    }
  }
}
</script>

<style scoped>
::v-deep .v-menu{
  overflow: auto ;
}
.button-bg{
  background-color: #F5FBFC;
}
.horizontal-align {
  display: flex;
}
.align-center{
  align-items: center;
}
</style>